import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helpersNumbers from "../../../helpers/numbers";
import httpService from "../../../services/httpServices/httpServices";
import financeTransactionAdd from "../../../validations/forms/finance/transaction/add";

function AddAskTransaction({ wallet }) {
  const [amount, setAmount] = useState(0);
  const [message, setMessage] = useState();
  const history = useHistory();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const inputBankCardNumberPartBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
    const number = e.target.value;
    if (number.length > 3) {
      e.preventDefault();
      return;
    }
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".card-body");
    element.scrollIntoView();
  };

  const sendForm = async () => {
    const dataForm = getDataForm();
    const resultFinanceTransactionAdd = financeTransactionAdd(dataForm);
    if (resultFinanceTransactionAdd != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultFinanceTransactionAdd,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultAddAskTransaction = await sendRequestAddAskTransaction(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultAddAskTransaction) {
      return;
    }

    history.push("/finance/ask-transaction/all");
  };

  const checkUserCanAddTransaction = () => {
    if (
      wallet <
      parseInt(process.env.REACT_APP_AMOUNT_WALLET_BLOCK_ASK_TRANSACTION) +
        parseInt(process.env.REACT_APP_MIN_AMOUNT_ASK_TRANSACTION)
    ) {
      return false;
    }
    return true;
  };

  const getDataForm = () => {
    return {
      wallet: wallet,
      price: amount + "",
      bank_name: document.querySelector("#bank-name").value,
      owner_account_name: document.querySelector("#owner-account").value,
      account_number: document.querySelector("#bank-account-number").value,
      account_cart_number: getBankAccountNumber(),
      account_shaba_number: document.querySelector("#shaba-number").value,
    };
  };

  const sendRequestAddAskTransaction = async (dataForm) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/ask-transaction",
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getBankAccountNumber = () => {
    return (
      document.querySelector("#card-number-1").value +
      "-" +
      document.querySelector("#card-number-2").value +
      "-" +
      document.querySelector("#card-number-3").value +
      "-" +
      document.querySelector("#card-number-4").value
    );
  };

  const generateFormAddAskTransaction = () => {
    return (
      <>
        <div className="alert alert-warning">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                مبلغ ۴۰۰ هزار تومان از حساب همه ی نماش دهندگان بلاک شده است و
                قابل انتقال نیست.
              </p>
            </li>
            <li>
              <p className="text-justify">
                حداقل مبلغ درخواستی برای انتقال وجه ۱۰۰ هزار تومان میباشد.
              </p>
            </li>
          </ul>
        </div>

        {messageTag}
        <table class="table table-hilite">
          <thead>
            <tr>
              <td>موجودی شما</td>
              <td>حداقل مبلغ درخواستی</td>
              <td> مبلغ بلاک حساب نمایش دهنده</td>
              <td>مبلغ قابل انتقال از موجودی</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <label className="pl-2 letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(wallet)
                  )}
                </label>
                <label>تومان</label>
              </td>
              <td>
                <label className="pl-2 letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(
                      process.env.REACT_APP_MIN_AMOUNT_ASK_TRANSACTION
                    )
                  )}
                </label>
                <label>تومان</label>
              </td>
              <td>
                <label className="pl-2 letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(
                      process.env.REACT_APP_AMOUNT_WALLET_BLOCK_ASK_TRANSACTION
                    )
                  )}
                </label>
                <label>تومان</label>
              </td>
              <td>
                <label className="pl-2 letter-spacing-finance-number">
                  {helpersNumbers.toPersianNum(
                    helpersNumbers.toFormatFinanceNumber(
                      wallet -
                        process.env
                          .REACT_APP_AMOUNT_WALLET_BLOCK_ASK_TRANSACTION
                    )
                  )}
                </label>
                <label>تومان</label>
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              sendForm();
            }}
          >
            <div className="form-group">
              <label>مبلغ (تومان)</label>
              <input
                tabindex="1"
                type="text"
                id="price"
                className="form-control number-finance"
                value={helpersNumbers.toPersianNum(
                  helpersNumbers.toFormatFinanceNumber(amount)
                )}
                onChange={inputAmountChangeHandler}
                onBeforeInput={inputAmountBeforeInputHandler}
                dir="ltr"
                required
              />
            </div>

            <div className="form-group">
              <label>نام بانک </label>
              <input
                tabindex="2"
                type="text"
                className="form-control"
                id="bank-name"
                required
              />
            </div>
            <div className="form-group">
              <label>نام مالک حساب</label>
              <input
                tabindex="3"
                type="text"
                className="form-control"
                id="owner-account"
                required
              />
            </div>

            <div className="form-group">
              <label>شماره حساب بانکی</label>
              <input
                tabindex="4"
                dir="ltr"
                type="text"
                id="bank-account-number"
                onBeforeInput={inputAmountBeforeInputHandler}
                class="form-control number-finance"
                required
              />
            </div>

            <div className="form-group">
              <label>شماره کارت بانکی </label>
              <div className="ltr d-flex">
                <div className="pr-2">
                  <input
                    tabindex="5"
                    dir="ltr"
                    type="text"
                    id="card-number-1"
                    className="form-control number-finance text-center"
                    onBeforeInput={inputBankCardNumberPartBeforeInputHandler}
                    required
                  />
                </div>
                <div className="pr-2">
                  <input
                    tabindex="6"
                    dir="ltr"
                    type="text"
                    id="card-number-2"
                    className="form-control number-finance text-center"
                    onBeforeInput={inputBankCardNumberPartBeforeInputHandler}
                    required
                  />
                </div>
                <div className="pr-2">
                  <input
                    tabindex="7"
                    dir="ltr"
                    type="text"
                    id="card-number-3"
                    className="form-control number-finance text-center"
                    onBeforeInput={inputBankCardNumberPartBeforeInputHandler}
                    required
                  />
                </div>
                <div>
                  <input
                    tabindex="8"
                    dir="ltr"
                    type="text"
                    id="card-number-4"
                    className="form-control number-finance text-center"
                    onBeforeInput={inputBankCardNumberPartBeforeInputHandler}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>شماره شبا </label>
              <div class="input-group">
                <input
                  tabindex="9"
                  type="text"
                  onBeforeInput={inputAmountBeforeInputHandler}
                  class="form-control number-finance"
                  dir="ltr"
                  id="shaba-number"
                  required
                />
                <div class="input-group-append">
                  <span class="input-group-text">IR</span>
                </div>
              </div>
            </div>

            <div className="form-group">
              <button className="btn btn-success">ارسال درخواست</button>
            </div>
          </form>
        </div>
      </>
    );
  };

  const generateUserPublisherCanNotAddAskTransaction = () => {
    return (
      <>
        <div className="alert alert-danger">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <p className="text-justify">
            شما نمی توانید ارسال درخواست انتقال موجودی بفرستید.مبلغ ۴۰۰ هزار
            تومان از حساب همه ی نماش دهندگان بلاک شده است و قابل انتقال نیست.
            حداقل مبلغ درخواستی برای انتقال وجه ۱۰۰ هزار تومان میباشد.
          </p>
          <p>
            حداقل موجودی برای ارسال درخواست انتقال موجودی مبلغ ۵۰۰ هزار تومان
            است
          </p>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="ارسال درخواست انتقال موجودی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/ask-transaction/all"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              {checkUserCanAddTransaction()
                ? generateFormAddAskTransaction()
                : generateUserPublisherCanNotAddAskTransaction()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    wallet: state.main.wallet,
  };
};

export default connect(mapStateToProps, null)(AddAskTransaction);
